
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img
              src="https://public.readdy.ai/ai/img_res/29cb4625-055a-4b6c-9f0b-d6804c39a8b0.png"
              alt="SPA Logo"
              className="h-12 w-12 object-contain"
            />
            <span className={`text-xl font-serif font-semibold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              GOLDEN MOUNTAIN spa
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-1">
            <button
              onClick={() => scrollToSection('hero')}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Home
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-white/50'}`}>•</span>
            <button
              onClick={() => scrollToSection('about')}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              About
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-white/50'}`}>•</span>
            <button
              onClick={() => scrollToSection('services')}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Services
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-white/50'}`}>•</span>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Gallery
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-white/50'}`}>•</span>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Reviews
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-white/50'}`}>•</span>
            <button
              onClick={() => scrollToSection('contact')}
              className={`px-4 py-2 text-sm font-medium transition-colors ${
                isScrolled ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'
              }`}
            >
              Contact
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <a 
              href="tel:0509348676" 
              className={`hidden lg:flex items-center space-x-2 px-4 py-2 rounded-full transition-all cursor-pointer ${
                isScrolled 
                  ? 'bg-amber-50 text-amber-900 hover:bg-amber-100' 
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              <i className="ri-phone-line text-lg"></i>
              <span className="font-semibold text-base">0509348676</span>
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-amber-900 text-white text-sm font-medium rounded-full hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Now →
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
